import { useEffect, useState } from 'react';
import useScrollBlock from './useScrollBlock';

const useLightbox = () => {

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [blockScroll, allowScroll] = useScrollBlock();

  useEffect(() => {
    // Prevent scrolling when modal is open
    // isModalOpen ? document.body.classList.add('modal-open') : document.body.classList.remove('modal-open');
    isLightboxOpen ? blockScroll() : allowScroll();
  }, [isLightboxOpen, blockScroll, allowScroll])

  function toggleLightbox() {
    setIsLightboxOpen(!isLightboxOpen);
  }

  return [
    isLightboxOpen,
    toggleLightbox,
  ]
  
};

export default useLightbox;